import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widget";
import Section from "./Section";
import SupportTrendByYear from "./SupportTrendByYear";
import PaymentCategoryChart from "./PaymentCategoryChart";
import PaymentCategoryAndRegion from "./PaymentCategoryAndRegion";
import DistributionByGender from "./DistributionByGender";

const Dashboard = () => {
  document.title = "Dashboard | CIRT";

  const [rightColumn, setRightColumn] = useState<boolean>(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section rightClickBtn={toggleRightColumn} />

                <Widget />

                <Row>
                  <Col xl={8}>
                    <SupportTrendByYear />
                  </Col>
                  <Col xl={4}>
                    <PaymentCategoryChart />
                  </Col>
                </Row>
                <Row>
                  <Col xl={4}>
                    <DistributionByGender />
                  </Col>
                  <Col xl={8}>
                    <PaymentCategoryAndRegion />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
